<template>
    <div>
        <h4>Etape 3 - Annonces</h4>
        <b-form-group label="URL finale de l'annonce :">
            <b-form-input v-model="form.finalUrl" />
            <span class="text-danger" v-if="!checkUrl">URL incorrete</span>
        </b-form-group>

        <b-form-group label="Chemin à afficher :">
            <div class="d-flex justify-content-between align-items-center">
                <b-form-input v-model="form.path1" class="col-sm-5" /> /
                <b-form-input v-model="form.path2" class="col-sm-5" />
            </div>
        </b-form-group>

        <div v-for="(title, index) in form.titles" :key="index">
            <b-form-group :label="'Titre ' + (index + 1) + ' :'">
                <b-form-input v-model="form.titles[index]" />
                <span class="text-danger" v-if="titleStates[index]"> Le titre ne doit pas dépasser 30 caractères </span>
            </b-form-group>
        </div>
        <span class="text-danger" v-if="checkTitles">Les Titres ne doivent pas être identiques</span>
        <div class="d-flex justify-content-between w-100 mt-1">
            <b-button class="mb-2" variant="primary" size="sm" @click="addTitle" :disabled="form.titles.length >= 15"> Ajouter un titre (jusqu'à 12) </b-button>
            <b-button class="mb-2" variant="danger" size="sm" v-if="form.titles.length > 3" @click="deleteTitle">- supprimer le titre</b-button>
        </div>

        <div v-for="(desc, index) in form.descriptions" :key="index + form.titles.length">
            <b-form-group :label="'Descriptions ' + (index + 1) + ' :'">
                <b-form-textarea v-model="form.descriptions[index]" />
                <span class="text-danger" v-if="descriptionStates[index]"> La description ne doit pas dépasser 90 caractères </span>
            </b-form-group>
        </div>
        <div class="d-flex justify-content-between w-100 mt-1">
            <b-button variant="primary" size="sm" @click="addDescription" :disabled="form.descriptions.length >= 6"> Ajouter une description (jusqu'à 4) </b-button>
            <b-button variant="danger" size="sm" v-if="form.descriptions.length > 2" @click="deleteDescription">- supprimer la description</b-button>
        </div>

        <div class="d-flex justify-content-between w-100 mt-3">
            <b-button variant="danger" @click="$emit('cancelEdit')">Annuler</b-button>
            <b-button variant="primary" @click="save" :disabled="disableAddBtn">{{ btnLabel }}</b-button>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['adGroups', 'currentAdGroupIndex', 'editingAdIndex'],
        data() {
            return {
                form: {
                    finalUrl: '',
                    path1: '',
                    path2: '',
                    titles: ['', '', ''],
                    descriptions: ['', ''],
                },
                titleCaracteresLenght: 30,
                descriptionCaracteresLenght: 90,
            };
        },
        computed: {
            btnLabel() {
                return this.editingAdIndex != null ? 'Modifier' : 'Ajouter';
            },
            disableAddBtn() {
                let disable = false;
                if (!this.form.finalUrl || !this.checkUrl) {
                    disable = true;
                }
                for (const title of this.form.titles) {
                    if (!title || this.checkTitles || title.length > this.titleCaracteresLenght) disable = true;
                }
                for (const description of this.form.descriptions) {
                    if (!description || description.length > this.descriptionCaracteresLenght) disable = true;
                }
                return disable;
            },
            checkUrl() {
                if (!this.form.finalUrl) return true;
                if (this.form.finalUrl.endsWith('/') || this.form.finalUrl.endsWith('?')) return false;
                const regex = /^https?:\/\/(www\.)?([a-zA-Z0-9-]{1,63}\.)?[a-zA-Z0-9-]{1,63}\.[a-zA-Z]{2,6}/;
                return regex.test(this.form.finalUrl);
            },
            checkTitles() {
                const duplicates = this.form.titles.filter((item, index) => this.form.titles.indexOf(item) !== index && item != '');
                return duplicates.filter((title) => title != '').length > 0;
            },
            titleStates() {
                return this.form.titles.map((title) => title.length > this.titleCaracteresLenght);
            },
            descriptionStates() {
                return this.form.descriptions.map((description) => description.length > this.descriptionCaracteresLenght);
            },
        },
        mounted() {
            const ads = this.adGroups[this.currentAdGroupIndex].ads || [];
            if (this.editingAdIndex !== null && ads[this.editingAdIndex]) {
                const ad = ads[this.editingAdIndex];
                this.form = {
                    finalUrl: ad.finalUrl || '',
                    path1: ad.path1 || '',
                    path2: ad.path2 || '',
                    titles: [...ad.titles] || [''],
                    descriptions: [...ad.descriptions] || [''],
                };
            }
        },
        methods: {
            save() {
                this.$emit('saveAd', { ...this.form });
            },
            addTitle() {
                if (this.form.titles.length < 15) this.form.titles.push('');
            },
            deleteTitle() {
                this.form.titles.splice(this.form.titles.length - 1, 1);
            },
            deleteDescription() {
                this.form.descriptions.splice(this.form.descriptions.length - 1, 1);
            },
            addDescription() {
                if (this.form.descriptions.length < 6) this.form.descriptions.push('');
            },
        },
    };
</script>
